module.exports = __webpack_public_path__ + "static/coronatools-4fb061595115f7f25583058dd7fd8dd8.png";